import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const SectionHeader = ({ title, subTitle, required, ...props }) => (
  <Wrapper className={props.className}>
    <TitleRow>
      <Title>{title}</Title>
      {required && <Required>*</Required>}
    </TitleRow>
    {subTitle && <SubTitle>{subTitle}</SubTitle>}
  </Wrapper>
)

SectionHeader.defaultProps = {
  required: true,
}

SectionHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  required: PropTypes.bool,
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`

const TitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`

const Title = styled.h1`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: #1d1e22;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 1px;
  margin: 0;

  @media screen and (min-width: 1000px) {
    font-size: 18px;
  }
`

const Required = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: #f00;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 200% */
  letter-spacing: 1px;
  margin: 0;
`

const SubTitle = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: #3e3e3e;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;

  /* Label 02/Regular */
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin: 0;
`

export default SectionHeader



// WEBPACK FOOTER //
// ./src/components/SectionHeader/index.js